import * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { RsvpUnitSkeleton } from './components/RsvpUnitSkeleton';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "MailListRsvpUI", webpackPrefetch: true */ './lazyIndex'
    )
);

export const ListViewRsvpUnit = createLazyComponent(
    lazyModule,
    m => m.ListViewRsvpUnit,
    RsvpUnitSkeleton
);
export const ReadingPaneRsvpUnit = createLazyComponent(
    lazyModule,
    m => m.ReadingPaneRsvpUnit,
    RsvpUnitSkeleton
);
